import React from 'react'
import PropTypes from 'prop-types'; // ES6 
import {Alert, Fade } from 'reactstrap';
import * as common from '../lib/common'

Alert.propTypes = {
  className: PropTypes.string,
  closeClassName: PropTypes.string,
  color: PropTypes.string, // default: 'success'
  isOpen: PropTypes.bool,  // default: true
  toggle: PropTypes.func,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  // Controls the transition of the alert fading in and out
  // See Fade for more details
  transition: PropTypes.shape(Fade.propTypes),
}

// Iterate over each error object and print them
// in an unordered list
const Errors = (props) => {
  const { errors } = props;
  let willshowing = false;
  if (errors && !!errors.length){
    for (let i = 0; i < errors.length; i++) { 
      if (errors[i].body != '')
      {
        willshowing = true
        break
      }
    }
  }

  return (
    <div>
      {errors.map(errors => (
        <Alert isOpen={willshowing} color="error" key={common.Uuid()}>{errors.body}</Alert>
      ))}
    </div>
  )
}

Errors.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      body: PropTypes.string,
      time: PropTypes.date,
    })),
}

export default Errors



// WEBPACK FOOTER //
// ./src/notifications/Errors.js